import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { getCurrentQuestionId, getAnsweredQuestionIds, getRelevantQuestions, getRemainingQuestionIds, getHasUnansweredQuestions, isQuestionAnswered } from '../_data/filterQuestions';
import { produce } from '@/globals/helpers/immer';
import { convertGivenAnswersToSearchParams, useGivenAnswers } from '../_data/useGivenAnswers';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { supergridColumns } from '@/uiPrimitives/layout/pageGrid/subgridColumns';
import { ResetButton } from './Reset';
import { QuestionButtons } from './currentQuestion/CurrentButtons';
import { Progress } from './Progress';
import { pushPreviousStepEvent, pushRestartEvent } from '@/globals/analytics/events/pushDecisionToolEvent';
import { getQuestionMethods } from './getQuestionMethods';
import { AnyRenderedQuestion } from './question.types';
import { unprintable } from '@/uiPrimitives/base/printable.css';
import { TitlePrefix } from '../_renderers/TitlePrefix';
import { AnsweredQuestionContainer } from './AnsweredQuestionParts';
import { pushDecisionToolSubmitEvents } from './pushDecisionToolSubmitEvents';
import { translateInline } from '@/globals/translate/translateInline';
import { hiddenAccessible } from '@/uiPrimitives/utility/display.css';
import { currentQuestionTransitionClass } from '../DecisionTool.css';
import { DecisionToolTransitionState } from '../useStartQuestionTransition';
export const Questions = t0 => {
  const $ = _c(34);
  const {
    questions,
    currentQuestionElId,
    startQuestionTransition,
    isDelayElapsed,
    hasStartedDecisionTool,
    hasViewedResult,
    onDecisionToolStarted,
    onResultViewed
  } = t0;
  const [givenAnswers, setGivenAnswers] = useGivenAnswers(questions);
  const [editingQuestionId, setEditingQuestionId] = useState(undefined);
  let hasUnansweredQuestions;
  let t1;
  let t2;
  let t3;
  if ($[0] !== currentQuestionElId || $[1] !== editingQuestionId || $[2] !== givenAnswers || $[3] !== hasStartedDecisionTool || $[4] !== hasViewedResult || $[5] !== isDelayElapsed || $[6] !== onDecisionToolStarted || $[7] !== onResultViewed || $[8] !== questions || $[9] !== setGivenAnswers || $[10] !== startQuestionTransition) {
    const relevantQuestions = getRelevantQuestions(questions, givenAnswers);
    const currentQuestionId = getCurrentQuestionId(relevantQuestions, givenAnswers, editingQuestionId);
    const currentQuestionTitle = relevantQuestions.find(question => question.id === currentQuestionId)?.titleText;
    const answeredQuestionIds = getAnsweredQuestionIds(relevantQuestions, givenAnswers, currentQuestionId);
    const remainingQuestionIds = getRemainingQuestionIds(relevantQuestions, givenAnswers, currentQuestionId);
    let t4;
    if ($[15] !== givenAnswers || $[16] !== questions) {
      t4 = getHasUnansweredQuestions(questions, givenAnswers);
      $[15] = givenAnswers;
      $[16] = questions;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    hasUnansweredQuestions = t4;
    let t5;
    if ($[18] !== givenAnswers) {
      t5 = question_0 => isQuestionAnswered({
        question: question_0,
        givenAnswers
      });
      $[18] = givenAnswers;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    const answeredQuestionsLength = relevantQuestions.filter(t5).length;
    t3 = answeredQuestionIds.length > 0 && <h2 className={hiddenAccessible}>{hasUnansweredQuestions ? translateInline({
        en: "Answered questions and current question",
        nl: "Beantwoorde vragen en huidige vraag"
      }) : translateInline({
        en: "Answered questions",
        nl: "Beantwoorde vragen"
      })}</h2>;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = classes(unprintable, supergridColumns({
        gridTemplateColumns: "auto minmax(0, 1fr) auto"
      }));
      $[20] = t1;
    } else {
      t1 = $[20];
    }
    t2 = relevantQuestions.map((question_1, index) => {
      const previousQuestionId = relevantQuestions[index - 1]?.id;
      const viewTransitionName = `question-list-item-${question_1.id}`;
      if (question_1.id === currentQuestionId && isDelayElapsed) {
        const progressSlot = editingQuestionId !== question_1.id && <Progress relevantQuestionsLength={relevantQuestions.length} remainingQuestionsLength={remainingQuestionIds.length} />;
        const onPrevious = previousQuestionId != null ? () => {
          startQuestionTransition(() => setEditingQuestionId(previousQuestionId));
          pushPreviousStepEvent({
            questionId: currentQuestionId || "-",
            questionTitle: currentQuestionTitle || "-"
          });
        } : undefined;
        const buttonsSlot = <QuestionButtons allQuestions={questions} givenAnswers={givenAnswers} onPrevious={onPrevious} />;
        const {
          Current
        } = getQuestionMethods(question_1.type);
        return <li key={question_1.id} className={classes(currentQuestionTransitionClass)} style={{
          viewTransitionName
        }}><TitlePrefix titlePrefix={question_1.titlePrefix} /><Current containerId={`${currentQuestionElId}-container`} titleId={`${currentQuestionElId}-title`} progressSlot={progressSlot} buttonsSlot={buttonsSlot} question={question_1} givenAnswers={givenAnswers} onSubmit={t6 => {
            const {
              givenAnswersProducer,
              getAnswerTitle
            } = t6;
            const nextGivenAnswers = produce(givenAnswers, draft => {
              givenAnswersProducer(draft);
            });
            startQuestionTransition(() => {
              setEditingQuestionId(undefined);
              setGivenAnswers(nextGivenAnswers);
            });
            const isCompletingDecisionTool = !getHasUnansweredQuestions(questions, nextGivenAnswers);
            pushDecisionToolSubmitEvents({
              answerTitle: getAnswerTitle(),
              answeredQuestionsLength,
              hasStartedDecisionTool,
              hasViewedResult,
              isCompletingDecisionTool,
              nextGivenAnswers,
              onDecisionToolStarted,
              onResultViewed,
              question: question_1,
              questions
            });
          }} /></li>;
      }
      if (answeredQuestionIds.includes(question_1.id) || question_1.id === currentQuestionId && !isDelayElapsed && editingQuestionId != null) {
        const {
          Answered
        } = getQuestionMethods(question_1.type);
        return <AnsweredQuestionContainer key={question_1.id} viewTransitionName={viewTransitionName}><TitlePrefix titlePrefix={question_1.titlePrefix} /><Answered question={question_1} givenAnswer={givenAnswers[question_1.type].get(question_1.id)} onEdit={() => {
            startQuestionTransition(() => setEditingQuestionId(question_1.id));
            pushPreviousStepEvent({
              questionId: currentQuestionId || "-",
              questionTitle: currentQuestionTitle || "-"
            });
          }} /></AnsweredQuestionContainer>;
      }
      return null;
    });
    $[0] = currentQuestionElId;
    $[1] = editingQuestionId;
    $[2] = givenAnswers;
    $[3] = hasStartedDecisionTool;
    $[4] = hasViewedResult;
    $[5] = isDelayElapsed;
    $[6] = onDecisionToolStarted;
    $[7] = onResultViewed;
    $[8] = questions;
    $[9] = setGivenAnswers;
    $[10] = startQuestionTransition;
    $[11] = hasUnansweredQuestions;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    hasUnansweredQuestions = $[11];
    t1 = $[12];
    t2 = $[13];
    t3 = $[14];
  }
  let t4;
  if ($[21] !== t1 || $[22] !== t2) {
    t4 = <ol className={t1}>{t2}</ol>;
    $[21] = t1;
    $[22] = t2;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== givenAnswers || $[25] !== hasUnansweredQuestions || $[26] !== questions || $[27] !== setGivenAnswers || $[28] !== startQuestionTransition) {
    t5 = !hasUnansweredQuestions && <ResetButton onClick={() => {
      pushRestartEvent({
        givenAnswersSearchParamsString: convertGivenAnswersToSearchParams(givenAnswers, questions).toString()
      });
      startQuestionTransition(() => {
        setEditingQuestionId(undefined);
        setGivenAnswers({
          single: new Map(),
          multiple: new Map(),
          matrix: new Map()
        });
      });
    }} />;
    $[24] = givenAnswers;
    $[25] = hasUnansweredQuestions;
    $[26] = questions;
    $[27] = setGivenAnswers;
    $[28] = startQuestionTransition;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  let t6;
  if ($[30] !== t3 || $[31] !== t4 || $[32] !== t5) {
    t6 = <>{t3}{t4}{t5}</>;
    $[30] = t3;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
  } else {
    t6 = $[33];
  }
  return t6;
};